import { useaxios } from "../../../utils/useaxios";
export default (from, to) => initDispatch => clear => settable_type => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/sell/most_sold.php', { from, to }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setmost_sell_report', payload: res.data });
            settable_type("most_sell_report");
        }
        // setloading(false);
    });
}